/**
 * Shows the product price based on the selected filter.
 * This function is called on page load and whenever filters are updated.
 * It updates the product cards to reflect the price of the matched variant(s).
 * Event : on:facet-filters:updated
 */
function normalizeLength(value) {
  return value.toLowerCase().replace(",", ".").replace(/\s+/g, "");
}

function parseLength(value) {
  // Try to find a value in meters (e.g. "8.2m" or "(8.2 m)")
  const meterMatch = value.match(/(\d+(\.\d+)?)\s*m/);
  if (meterMatch) return parseFloat(meterMatch[1]);
  // Fallback: extract first number
  const fallback = value.match(/(\d+(\.\d+)?)/);
  return fallback ? parseFloat(fallback[1]) : NaN;
}

function matchFilterToVariant(filters, variants) {
  return filters
    .map((f) => {
      const fVal = parseLength(f);
      let best = null,
        bestDiff = Infinity;
      for (const v of variants) {
        const vVal = parseLength(v.name);
        const diff = vVal - fVal;
        if (diff >= 0 && diff < bestDiff) {
          best = v;
          bestDiff = diff;
        }
      }
      return best;
    })
    .filter(Boolean);
}

// function formatMoney(amount) {
//   // Use window.money_format or default to '€{{amount}}'
//   const format = window.money_format || "€{{amount}}";
//   // Format amount with comma as decimal separator and dot as thousands separator
//   const formattedAmount = amount
//     .toFixed(2)
//     .replace(/\B(?=(\d{3})+(?!\d))/g, ".") // thousands separator
//     .replace(".", ","); // decimal separator

//   // Handle different placeholders
//   if (format.includes("{{amount_with_comma_separator}}")) {
//     // Shopify-style: thousands separator is dot, decimal is comma
//     return format.replace("{{amount_with_comma_separator}}", formattedAmount);
//   }
//   if (format.includes("{{amount}}")) {
//     // Fallback: just replace {{amount}}
//     return format.replace("{{amount}}", formattedAmount);
//   }
//   return formattedAmount;
// }

// function parsePriceString(value) {
//   if (!value) return NaN;
//   // Remove thousands separator and normalise decimal
//   const normalised = value.replace(/\./g, "").replace(",", ".");
//   const amount = Number(normalised);
//   return Number.isNaN(amount) ? NaN : amount;
// }

function getActiveFilters() {
  const params = new URLSearchParams(window.location.search);
  // Support both werklengte and lengte_stelen filters, but only allow one value (prefer werklengte if present)
  const werklengte = params.get("filter.p.m.gebruik.werklengte");
  const lengteStelen = params.get("filter.p.m.gebruik.lengte_stelen");
  return werklengte ? [werklengte] : lengteStelen ? [lengteStelen] : [];
}

function getAllActiveFilters() {
  const params = new URLSearchParams(window.location.search);
  const filters = {};
  for (const [key, value] of params.entries()) {
    if (key.startsWith("filter.p.m.gebruik.")) {
      if (!filters[key]) filters[key] = [];
      filters[key].push(value);
    }
  }
  return filters;
}
function updateProductCards() {
  const cards = document.querySelectorAll("product-card.card--product");

  cards.forEach((card) => {
    let variants = [];
    try {
      variants = JSON.parse(card.dataset.variants);
    } catch (e) {
      // If variants data is malformed, skip this card
      return;
    }
    const activeFilters = getActiveFilters();
    const matched = matchFilterToVariant(activeFilters, variants);

    const priceCurrentStrong = card.querySelector(".price__current > strong");
    const priceCompareAt = card.querySelector(".price__default > s.price__was");
    const priceFromEl = card.querySelector(".price__default .price__from");
    const swatchItems = card.querySelectorAll(".product-block-options .product-block-options__item");
    const matchedNames = new Set(matched.map((v) => normalizeLength(v.name)));

    let anyVisible = false;
    swatchItems.forEach((item) => {
      const itemVal = normalizeLength(item.getAttribute("data-option-item") || "");
      const isMatch = matchedNames.has(itemVal);
      item.classList.toggle("is-active", isMatch);
      // item.classList.toggle("hide", !isMatch);
      if (isMatch) anyVisible = true;
    });

    const swatchParent = card.querySelector(".product-block-options.product-block-options--swatch");
    if (swatchParent) {
      swatchParent.classList.toggle("hide", !anyVisible);
    }

    const linkEls = card.querySelectorAll("a.js-prod-link");
    if (matched.length) {
      const v = matched[0];
      let href = card.dataset.url;
      href += href.includes("?") ? `&variant=${v.id}` : `?variant=${v.id}`;
      linkEls.forEach((a) => a.setAttribute("href", href));

      const cheapest = matched.reduce((a, b) => (a.priceAmount <= b.priceAmount ? a : b));
      if (priceCurrentStrong) priceCurrentStrong.textContent = cheapest.price || "";

      const onSale = matched.filter((v) => v.compareAtPriceAmount > v.priceAmount);
      if (priceCompareAt) {
        if (onSale.length > 0) {
          const cheapestCompare = onSale.reduce((a, b) => (a.compareAtPriceAmount <= b.compareAtPriceAmount ? a : b));
          priceCompareAt.textContent = cheapestCompare.compareAtPrice || "";
        } else {
          priceCompareAt.textContent = "";
        }
      }
    }

    if (activeFilters.length === 0 && priceFromEl) {
      // No filter: always show "from" price
      priceFromEl.classList.remove("hide");
    } else if (matched.length > 1 && activeFilters.length > 1 && priceFromEl) {
      // Show "from" price if multiple filters and multiple variants matched
      priceFromEl.classList.remove("hide");
    } else if (priceFromEl) {
      priceFromEl.classList.add("hide");
    }

    // Sync quick-add button label: "Add to cart" when a variant is selected, "Choose options" otherwise.
    const quickAddBtn = card.querySelector(".js-quick-add");
    if (quickAddBtn) {
      const textEl = quickAddBtn.querySelector(".quick-add-btn-text");
      if (matched.length > 0) {
        card.dataset.selectedVariantId = String(matched[0].id);
        quickAddBtn.dataset.selectedVariantId = String(matched[0].id);
        if (textEl) {
          textEl.textContent = quickAddBtn.dataset.addToCartText || "Add to cart";
        }
      } else {
        delete card.dataset.selectedVariantId;
        delete quickAddBtn.dataset.selectedVariantId;
        if (textEl) {
          textEl.textContent = quickAddBtn.dataset.chooseOptionsText || "Choose options";
        }
      }
    }
  });
}

/**
 * Disable Lengte Stelen filters when a Werklengte filter is selected, to avoid conflicts
 */
function disableLengthStelenFilter() {
  const lengthStelenCheckboxes = document.querySelectorAll('input[type="checkbox"][name="filter.p.m.gebruik.lengte_stelen"]');
  lengthStelenCheckboxes.forEach((cb) => {
    if (cb.checked) return; // don't disable if already checked
    cb.disabled = true;
  });
}

/**
 * Disable Werklengte filters when a Lengte Stelen filter is selected, to avoid conflicts
 */
function disableWorkLengthFilter() {
  const workLengthCheckboxes = document.querySelectorAll('input[type="checkbox"][name="filter.p.m.gebruik.werklengte"]');
  workLengthCheckboxes.forEach((cb) => {
    if (cb.checked) return; // don't disable if already checked
    cb.disabled = true;
  });
}

/**
 * If any Werklengte filter is selected, disable Gewicht and Aantal Delen filters
 * This function is called on page load and whenever filters are updated.
 * Event : on:facet-filters:updated
 */
function handleWorkLengthCheckboxes() {
  const workLengthCheckboxes = document.querySelectorAll('input[type="checkbox"][name="filter.p.m.gebruik.werklengte"]');
  workLengthCheckboxes.forEach((cb) => {
    if (cb.checked) {
      disableWorkLengthFilter();
      disableLengthStelenFilter();
    }
    cb.addEventListener("change", function () {
      if (cb.checked) {
        disableWorkLengthFilter();
        disableLengthStelenFilter();
      }
    });
  });
}

/**
 * If any Lengte Stelen filter is selected, disable Werklengte filters
 * This function is called on page load and whenever filters are updated.
 * Event : on:facet-filters:updated
 */
function handleLengthStelenCheckboxes() {
  const lengthStelenCheckboxes = document.querySelectorAll('input[type="checkbox"][name="filter.p.m.gebruik.lengte_stelen"]');
  lengthStelenCheckboxes.forEach((cb) => {
    if (cb.checked) {
      disableWorkLengthFilter();
      disableLengthStelenFilter();
    }
    cb.addEventListener("change", function () {
      if (cb.checked) {
        disableWorkLengthFilter();
        disableLengthStelenFilter();
      }
    });
  });
}

/**
 * Handle clicks on variant options in product cards (PLP)
 * When a variant option is clicked, update the product URL and navigate to it
 */
/**
 * After facet filters reload (length cleared from a card swatch or length chip), re-apply that selection on the card.
 * kind: "color" (default) = .opt-btn; "length" = .product-block-options__item
 */
function restoreSwatchAfterFilterClear() {
  let raw;
  try {
    raw = sessionStorage.getItem("hc-plp-swatch-restore");
  } catch (e) {
    return;
  }
  if (!raw) return;
  try {
    sessionStorage.removeItem("hc-plp-swatch-restore");
  } catch (e) {
    // ignore
  }
  let payload;
  try {
    payload = JSON.parse(raw);
  } catch (e) {
    return;
  }
  const { productPath, variantId, kind } = payload;
  if (!productPath || !variantId) return;

  const cards = document.querySelectorAll("product-card.card--product");
  let card = null;
  cards.forEach((c) => {
    const urlRaw = c.dataset.url || (c.querySelector(".js-quick-add") && c.querySelector(".js-quick-add").dataset.productUrl);
    if (!urlRaw) return;
    let path = "";
    try {
      path = new URL(urlRaw, window.location.origin).pathname;
    } catch (e) {
      path = urlRaw;
    }
    if (path === productPath) card = c;
  });
  if (!card) return;

  if (kind === "length") {
    const chip = card.querySelector(`.product-block-options__item[data-variant-id="${String(variantId).replace(/"/g, '\\"')}"]`);
    if (chip && !chip.classList.contains("product-block-options__item--unavailable")) {
      chip.dispatchEvent(new MouseEvent("click", { bubbles: true, cancelable: true, view: window }));
    }
    return;
  }

  const vid = String(variantId).replace(/\\/g, "\\\\").replace(/"/g, '\\"');
  const opt = card.querySelector(`.opt-btn[data-variant-id="${vid}"]`);
  if (!opt) return;
  opt.checked = true;
  opt.dispatchEvent(new Event("change", { bubbles: true }));
}

function handleVariantOptionClicks() {
  const variantOptions = document.querySelectorAll(".product-block-options__item[data-variant-id]");

  variantOptions.forEach((option) => {
    // Skip if already has click handler (check for data attribute)
    if (option.dataset.hasClickHandler === "true") return;

    // Mark as having click handler
    option.dataset.hasClickHandler = "true";

    option.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      // Don't navigate if item is unavailable
      if (this.classList.contains("product-block-options__item--unavailable")) {
        return;
      }

      const variantId = this.getAttribute("data-variant-id");
      if (!variantId) return;

      // Visually mark this option as active within its group
      const siblingItems = this.parentElement.querySelectorAll(".product-block-options__item");
      siblingItems.forEach((el) => {
        el.classList.toggle("is-active", el === this);
      });

      // Find the parent product card
      const productCard = this.closest("product-card.card--product");
      if (!productCard) return;

      // Get the base product URL
      const baseUrl = productCard.dataset.url;
      if (!baseUrl) return;

      // Construct the new URL with variant parameter
      const separator = baseUrl.includes("?") ? "&" : "?";
      const newUrl = `${baseUrl}${separator}variant=${variantId}`;

      // Update all product links in the card so that when the user
      // chooses to navigate, the correct variant is preselected.
      const productLinks = productCard.querySelectorAll("a.js-prod-link");
      productLinks.forEach((link) => {
        link.href = newUrl;
      });

      // Update price on the product card for the selected variant (no redirect).
      const priceCurrentStrong = productCard.querySelector(".price__current > strong");
      const priceCompareAt = productCard.querySelector(".price__default > s.price__was");
      const priceFromEl = productCard.querySelector(".price__default .price__from");

      try {
        const variants = JSON.parse(productCard.dataset.variants || "[]");
        const selectedVariant = variants.find((v) => String(v.id) === String(variantId));

        if (selectedVariant) {
          if (priceCurrentStrong) {
            // const priceAmount = parsePriceString(selectedVariant.price || "");
            // const compareAmount = parsePriceString(selectedVariant.compare_at_price || "");
priceCurrentStrong.textContent = selectedVariant.price || ""; 
            // if (!Number.isNaN(priceAmount)) {
            //   priceCurrentStrong.textContent = formatMoney(priceAmount);
            // }
            if (priceCompareAt) {
              // if (!Number.isNaN(compareAmount) && compareAmount > priceAmount) {
              //   priceCompareAt.textContent = formatMoney(compareAmount);
              if (selectedVariant.compareAtPriceAmount > selectedVariant.priceAmount) {                                                     
      priceCompareAt.textContent = selectedVariant.compareAtPrice || "";   
                priceCompareAt.classList.remove("hide");
              } else {
                priceCompareAt.classList.add("hide");
              }
            }

            if (priceFromEl) {
              priceFromEl.classList.add("hide");
            }
          }

          // Mark selected variant on the card and quick-add button so direct ATC and button label stay in sync.
          productCard.dataset.selectedVariantId = variantId;
          const quickAddBtn = productCard.querySelector(".js-quick-add");
          if (quickAddBtn) {
            quickAddBtn.dataset.selectedVariantId = String(selectedVariant.id);
            const textEl = quickAddBtn.querySelector(".quick-add-btn-text");
            if (textEl) {
              textEl.textContent = quickAddBtn.dataset.addToCartText || "Add to cart";
            }
          }
        }

        const params = new URLSearchParams(window.location.search);
        const hadLengthFacet =
          params.has("filter.p.m.gebruik.werklengte")
          || params.has("filter.p.m.gebruik.lengte_stelen");
        if (hadLengthFacet) {
          params.delete("filter.p.m.gebruik.werklengte");
          params.delete("filter.p.m.gebruik.lengte_stelen");
          const facetFiltersEl = document.querySelector("facet-filters");
          if (facetFiltersEl && typeof facetFiltersEl.applyFilters === "function") {
            const productUrlRaw =
              productCard.dataset.url
              || (productCard.querySelector(".js-quick-add") && productCard.querySelector(".js-quick-add").dataset.productUrl)
              || "";
            let productPath = "";
            try {
              productPath = new URL(productUrlRaw, window.location.origin).pathname;
            } catch (e) {
              productPath = productUrlRaw;
            }
            try {
              sessionStorage.setItem(
                "hc-plp-swatch-restore",
                JSON.stringify({
                  productPath,
                  variantId,
                  kind: "length"
                })
              );
            } catch (e) {
              // ignore
            }
            facetFiltersEl.applyFilters(params.toString(), null);
          }
        }
      } catch (err) {
        // If variant data is malformed, safely ignore and leave price as-is
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", function () {
  updateProductCards();
  handleWorkLengthCheckboxes();
  handleLengthStelenCheckboxes();
  handleVariantOptionClicks();
});

document.addEventListener("on:facet-filters:updated", function () {
  updateProductCards();
  handleLengthStelenCheckboxes();
  handleWorkLengthCheckboxes();
  handleVariantOptionClicks();
  restoreSwatchAfterFilterClear();
});
